import { z } from 'zod';
import { AuthProvider, UserStatus } from '../enums.js';
import {
  E164PhoneSchema,
  EmailSchema,
  Iso3CountrySchema,
  IsoDateTimeSchema,
  IsoLanguageSchema,
  UuidSchema,
} from '../primitives.js';

/**
 * Core user record. PII-sensitive; phone is encrypted at rest, email
 * unique-constrained, DOB stored on the profile (not here).
 */
export const UserSchema = z.object({
  id: UuidSchema,
  email: EmailSchema,
  emailVerifiedAt: IsoDateTimeSchema.nullable(),
  phoneE164: E164PhoneSchema.nullable(),
  phoneVerifiedAt: IsoDateTimeSchema.nullable(),
  phoneCountryCode: Iso3CountrySchema.nullable(),
  status: UserStatus,
  banReason: z.string().nullable(),
  bannedAt: IsoDateTimeSchema.nullable(),
  livenessVerifiedAt: IsoDateTimeSchema.nullable(),
  createdAt: IsoDateTimeSchema,
  lastSeenAt: IsoDateTimeSchema.nullable(),
  preferredLocale: IsoLanguageSchema.default('en'),
});
export type User = z.infer<typeof UserSchema>;

/** Linked auth identity (Google, Facebook, Apple, email-password). */
export const AuthIdentitySchema = z.object({
  id: UuidSchema,
  userId: UuidSchema,
  provider: AuthProvider,
  providerUserId: z.string().min(1),
  emailAtProvider: EmailSchema.nullable(),
  createdAt: IsoDateTimeSchema,
});
export type AuthIdentity = z.infer<typeof AuthIdentitySchema>;
